<template>
  <div class="aw ah">
    <cesiumViewer
      class="cesium-viewer"
      ref="cesiumViewer"
      @cesiumMsg="onCesiumMsg"
      @selectPrimitive="onSelectPrimitive"
    ></cesiumViewer>
    <div v-if="routerAlive">
      <MarkerDetail
        ref="markerDetail"
        @livePreviewMsg="openLivePreview"
        @previewPicMsg="onPreviewPic"
        @showHTMLEditorMsg="onShowHTMLEditor"
      ></MarkerDetail>
      <livePreview ref="livePreview"></livePreview>
      <PreviewPicture ref="previewPicture"></PreviewPicture>
      <MarkerAttributeEditor ref="markerAttributeEditor" :readonly="!!shared"></MarkerAttributeEditor>
    </div>
  </div>
</template>

<script>
import cesiumViewer from '@/components/cesiumViewer'
import MarkerDetail from '../operatingPlatform/Marker/components/MarkerDetail'
import livePreview from '@/components/live-preview'
import PreviewPicture from '@/components/PreviewPicture/PreviewPicture'
import MarkerAttributeEditor from '@/components/MarkerAttributeEditor'
import { mapActions, mapGetters } from 'vuex'
import { getMapDetails } from '@/api/mapManagement'
import { getMapModel } from '@/api/marker'
import { treeForeach } from '@/utils/tree'
import { getMapStyle } from '@/api/mapStyle'
import axios from '@/utils/request'

export default {
  name: 'mapComponent',
  components: {
    cesiumViewer,
    MarkerDetail,
    livePreview,
    PreviewPicture,
    MarkerAttributeEditor
  },
  data () {
    return {
      routerAlive: true,
      // routes: routes[1].children,
      query: undefined,
      tilesetOptions: {
        maximumScreenSpaceError: undefined,
        maximumMemoryUsage: undefined
      }
    }
  },
  computed: {
    ...mapGetters(['userId', 'selectedMarker'])
  },
  watch: {
    selectedMarker (val, oldVal) {
      if (val) {
        this.showMarkerDetail(true, val)
      } else {
        if (this.$refs.markerDetail.visible) {
          this.showMarkerDetail(false)
        }
      }
    }
  },
  created () {
    this.mapId = this.$route.query.mapId
    if (!this.mapId) {
      this.mapId = 0
    }
    this.canvaShare = this.$route.query.canvaShare
    if (this.canvaShare) {
      axios.defaults.headers.canvaShare = this.canvaShare
    }
    window.axios = axios
    // this.setCurMapId(this.mapId)
    this.query = this.$route.query
    this.$store.commit('SET_CURMAP', this.mapId)
    this.$store.commit('SET_ISTEMPLATE', !!this.$route.query.template)

    this.$store.dispatch('getLayerTree')
    this.$store.dispatch('getMarkerIcons')
    // this.$store.dispatch('getLayerList', { refreshMarker: true })
    this.$store.dispatch('getDefaultViewPoint')
    this.$store.dispatch('getFrequentlyViewPoint')
  },
  async mounted () {
    await this.loadMapModel()
    await this.getLayerList()
    await this.getMarkerList()
    this.$cesiumPlus.compassView.show(false)
  },
  destroyed () {
    this.$store.commit('resetMapState')
  },
  methods: {
    async refresh () {
      this.routerAlive = false
      await this.$nextTick()
      this.routerAlive = true
    },
    ...mapActions(['setCurMapId', 'getLayerList', 'getMarkerList']),
    onCesiumMsg (type, data) {

    },
    // 获取地图样式设置
    async getMapStyle () {
      const res = await getMapStyle({ mapId: this.$route.query.mapId })
      if (res.code === 200 && res.data) {
        // 地图底图
        this.$cesiumPlus.imageryManager.switchBaseLayer(
          CesiumPlus.LayerDefine[res.data.mapStyle]
        )
        if (res.data.labelLayer) {
          this.$cesiumPlus.imageryManager.switchLabelLayer(
            CesiumPlus.LayerDefine[res.data.labelLayer]
          )
        }
        // 地图亮度
        this.$cesiumPlus.imageryManager.getBaseLayer().brightness =
            res.data.mapBrightness * 0.1
        // 模型亮度
        const brightnessStage = this.$brightnessStage
        brightnessStage.uniforms.brightness = res.data.modelBrightness * 0.1
        // this.$cesiumPlus.viewer.scene.postProcessStages.add(brightnessStage)
        this.$store.commit('SELECT_MODELHEIGHT', res.data.modelHeight)
        // 3dTileset属性
        this.tilesetOptions = {
          maximumScreenSpaceError: res.data.maximumScreenSpaceError,
          maximumMemoryUsage: res.data.maximumMemoryUsage
        }
      }
    },
    async loadMapModel () {
      await this.getMapStyle()
      const res = await getMapDetails({ id: this.mapId })
      const res2 = await getMapModel({ id: res.data.areaId })
      if (res2.code === 200 && res2.data) {
        if (res2.data.model) {
          this.$refs.cesiumViewer.loadServerRes(res2.data.model.link, Object.assign(res2.data.model, this.tilesetOptions))
        }
        if (res2.data.children && res2.data.children.length) {
          treeForeach(res2.data.children, 'children', (item) => {
            if (item && item.model) {
              this.$refs.cesiumViewer.loadServerRes(item.model.link, Object.assign(item.model, this.tilesetOptions))
            }
          })
        }
      }
    },
    // 直播预览
    openLivePreview (data) {
      this.$refs.livePreview.open(data)
    },
    // 图片预览
    onPreviewPic (data) {
      this.$refs.previewPicture.open(data.list, data.index)
    },
    showMarkerDetail (isShow, data) {
      if (isShow) {
        this.$refs.markerDetail.show(data)
      } else {
        this.$refs.markerDetail.close()
      }
    },
    onSelectPrimitive (data) {
      if (!data) {
        const selectedPrimitiveId = this.$refs.cesiumViewer.selectedPrimitiveId
        if (selectedPrimitiveId && selectedPrimitiveId.startsWith('billboard-')) {
          const ids = selectedPrimitiveId.replace('billboard-', '').split('-')
          // const [layerId, id] = ...ids
          const bundle = this.$cesiumPlus.primitiveManager.getBundle(ids[0])
          if (!bundle) {
            console.error('can not find bundle, ', ids[0])
            return
          }
          const billboard = bundle.getBillboard(selectedPrimitiveId)
          if (billboard) {
            billboard.scale = bundle.style._scale
          }
        }
        this.$refs.cesiumViewer.selectedPrimitiveId = undefined
        return
      }
      const layerId = data.layerId
      const bundle = this.$cesiumPlus.primitiveManager.getBundle(layerId)
      if (!bundle) {
        console.error('can not find bundle, ', layerId)
        return
      }
      const billboardId = `billboard-${layerId}-${data.id}`
      const primitive = bundle.getBillboard(billboardId)
      if (!primitive) {
        return
      }
      this.$cesiumPlus.cameraManager.zoomToPosition(primitive.position)
      bundle.forEach(billboard => {
        billboard.scale = billboard.id === primitive.id ? 1.5 : bundle.style._scale
      })
      this.$refs.cesiumViewer.selectedPrimitiveId = primitive.id

      this.showMarkerDetail(true, {
        dataSourceType: 'API',
        ...data
      })
    },
    // 显示图文弹窗
    onShowHTMLEditor (data) {
      this.$refs.markerAttributeEditor.show({
        ...data
      })
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.mapComponent {
  width: 100%;
  height: 100%;
}
</style>
